import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getDataTokenSelector } from "../../../../store/selectors/authSelector";
import Languages from "./components/languages";
import UserMenuHeader from "./components/menu";
import { HeaderContainer, Logo, NavButton } from "./styled";
import ModalForm from "../../../utils/modalForm";
import LoadingModal from "../../../utils/modalLoading";
import { useNavigate } from "react-router";
import ModalSecondForm from "../../../utils/modalSecondForm";
import PATHS from "../../../../constants/paths";
import { t } from "i18next";
import { Can } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";

const Header = (props) => {
  const token = useSelector(getDataTokenSelector);
  const navigate = useNavigate();

  return (
    <>
      <LoadingModal />
      <ModalForm />
      <ModalSecondForm />
      <HeaderContainer className={`row justify-content-between`}>
        <div className="col-2 col-md-6 col-lg-4 align-self-center">
          <Logo
            src={`/assets/images/logo.png`}
            alt="logo"
            className="logo d-none d-lg-block"
          />
        </div>

        <div className="col-6 d-flex justify-content-end align-items-center">
          <div className="row">
            <div className="col-12 d-flex">
              <NavButton
                className="btn me-3 text-white "
                onClick={() => navigate(PATHS.HOME)}
              >
                {t("home")}
              </NavButton>
              <Can do={USER_PERMISSIONS.VIEW_COURSE}>
                <NavButton
                  className="btn me-3 text-white "
                  onClick={() => navigate(PATHS.LIST_COURSE)}
                >
                  {t("course")}
                </NavButton>
              </Can>

              <NavButton
                className="btn me-3 text-white "
                onClick={() => navigate(PATHS.LIST_MEETING)}
              >
                {t("meeting")}
              </NavButton>

              <NavButton
                className="btn me-3 text-white "
                onClick={() => navigate(PATHS.LIST_SESSION)}
              >
                {t("session")}
              </NavButton>

              <Languages />
              {token && <UserMenuHeader />}
            </div>
          </div>
        </div>
      </HeaderContainer>
    </>
  );
};

Header.propTypes = {
  withSidebar: PropTypes.bool,
  toggleFunc: PropTypes.func,
};

export default Header;
